import proj4 from 'proj4';
import { Point } from 'ol/geom';
import { transform, transformExtent } from 'ol/proj';
import { register } from 'ol/proj/proj4';

/** projection 값 가져오기 (sessionStorage → 없으면 URL) */
const getProjection = (): string => {
  let proj = sessionStorage.getItem('projection');

  if (!proj) {
    const params = new URLSearchParams(window.location.search);
    proj = params.get('projection') || 'EPSG:4326'; // 기본값 지정 가능
    sessionStorage.setItem('projection', proj); // 한 번 받아오면 세션에 저장
  }

  return proj;
};

export const targetProjection = getProjection();
export const baseProjection = targetProjection === 'EPSG:9214' ? 'EPSG:3857' : targetProjection;

interface TransProjection {
  latitude: number;
  longitude: number;
  targetProjection?: string;
}

export const extent5179 = [90112, 1192896, 2187264, 2765760];

/** Projection 설정 */
proj4.defs('EPSG:5176', '+proj=tmerc +lat_0=38 +lon_0=129.0028902777778 +k=1 +x_0=200000 +y_0=500000 +ellps=bessel +units=m +no_defs +towgs84=-115.80,474.99,674.11,1.16,-2.31,-1.63,6.43');
proj4.defs('EPSG:5183', '+proj=tmerc +lat_0=38 +lon_0=129 +k=1 +x_0=200000 +y_0=500000 +ellps=GRS80 +units=m +no_defs');
proj4.defs('EPSG:5179', '+proj=tmerc +lat_0=38 +lon_0=127.5 +k=0.9996 +x_0=1000000 +y_0=2000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs');
proj4.defs('EPSG:5186', '+proj=tmerc +lat_0=38 +lon_0=127 +k=1 +x_0=200000 +y_0=600000 +ellps=GRS80 +units=m +no_defs');
proj4.defs('EPSG:5187', '+proj=tmerc +lat_0=38 +lon_0=129 +k=1 +x_0=200000 +y_0=600000 +ellps=GRS80 +units=m +no_defs');
proj4.defs('EPSG:5185', '+proj=tmerc +lat_0=38 +lon_0=125 +k=1 +x_0=200000 +y_0=600000 +ellps=GRS80 +units=m +no_defs');
proj4.defs('EPSG:9214', '+proj=tmerc +lat_0=0 +lon_0=107 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,-0.00928836,0.01975479,-0.00427372,0.252906278 +units=m +no_defs +type=crs');
proj4.defs('EPSG:9210', '+proj=tmerc +lat_0=0 +lon_0=105.75 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs');

proj4.defs('EPSG:4326', '+proj=longlat +datum=WGS84 +no_defs +type=crs');
proj4.defs('EPSG:4756', '+proj=tmerc +lat_0=0 +lon_0=105 +k=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs');

register(proj4);

/** 4326 좌표계 ---> 5179 반환타입 ARR */
export const trans4326To5186 = ({ latitude, longitude }: TransProjection) => {
  return new Point(transform([longitude, latitude], 'EPSG:4326', baseProjection)).getCoordinates();
};
/** 5186 좌표계 ---> 5179 반환타입 ARR */
export const trans5186To5179 = ({ latitude, longitude }: TransProjection) => {
  return new Point(transform([longitude, latitude], 'EPSG:5186', baseProjection)).getCoordinates();
};

/** 9214 좌표계 ---> 3857 반환타입 ARR */
export const trans9214To3857 = ({ latitude, longitude }: TransProjection) => {
  return new Point(transform([longitude, latitude], 'EPSG:9214', baseProjection)).getCoordinates();
};

export const transProjection = ({ latitude, longitude, targetProjection }: TransProjection) => {
  return new Point(transform([longitude, latitude], targetProjection, baseProjection)).getCoordinates();
};

export const transformExtentProj = (extent, baseProjection) => {
  return transformExtent(
    extent, // 기존 extent
    targetProjection, // 원래 좌표계
    baseProjection, // 바꿀 좌표계
  );
};
